import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-consulta-postulaciones',
  templateUrl: '../../pages/consulta-postulaciones/consulta-postulaciones.component.html',
  styleUrls: ['../../pages/consulta-postulaciones/consulta-postulaciones.component.css']
})
export class ConsultaPostulacionesComponent implements OnInit 
{
    postulaciones: Postulaciones[]
    rol: string = localStorage.getItem("rol")
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 5 }
    tipoPostulacion : string = "Disponibles"
    tiposBeca: any = []

    constructor(public router: Router, public postulacionesService:PostulacionesService, 
                private dialog: MatDialog, private tiposService: TiposService) { }

    ngOnInit(): void 
    {
        //this.postulacionesDisponibles()
        console.log(screen.width)
    }

    postulacionesDisponibles()
    {
        let vm = this
            
        vm.tipoPostulacion = "Disponibles"

        this.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username")).then
        (
            (postulaciones: any) =>
            {
                vm.postulaciones = postulaciones
                
                vm.config.currentPage = 1
                vm.config.totalItems = vm.postulaciones.length
            }
        )
        .catch ( error =>
        {
            console.log(error)

            vm.postulaciones = []            
            vm.config.totalItems = 0
            
            if(error.status == 404) vm.openAlertDialog("No se han encontrado postulaciones disponibles.", "btn-dark")           
        } )
    }

    postulacionesAsignadas()
    {
        let vm = this

        vm.tipoPostulacion = "Asignadas"
        this.postulacionesService.traePostulacionesAsignadas(localStorage.getItem("idUsuario")).then
        (
            (postulaciones: any) =>
            {
                vm.postulaciones = postulaciones
                
                vm.config.currentPage = 1
                vm.config.totalItems = vm.postulaciones.length
            }
        )
        .catch ( error => 
        { 
            console.log(error)

            vm.postulaciones = []            
            vm.config.totalItems = 0
        } )
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, 
        {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
        } )
    }

    verArchivo(postulacionId: any)
    {
        let vm = this

        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {
                console.log(archivos)
                
                const byteCharacters = atob(archivos[0].archivo.split(',')[1])
                const byteNumbers = new Array(byteCharacters.length)
                
                for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i) }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: archivos[0].extension});
                
                var fileURL = URL.createObjectURL(blob)
                window.open(fileURL)
            }
        )
        .catch ( error =>  
        {
            console.log(error)

            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        } )        
    }

    pageChanged(event: any) { this.config.currentPage = event }
}